class SiteHeader {
    constructor(el, stickyOffset) {
        this.el = el;
        this.elMobile = document.querySelector('.site-header-mobile');

        this.isSticky = false;
        this.isTicking = false;
        this.stickyOffset = stickyOffset;
        this.lastScrollPosition = window.scrollY;
        this.updateFn = this._update.bind(this);

        if(this.el) {
            this._calculateHeaderHeight();
            this._onScroll();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        this.onCalculateHeaderHeightFn = this._calculateHeaderHeight.bind(this);

        window.addEventListener('scroll', this.onScrollFn);
        window.addEventListener('resize', this.onCalculateHeaderHeightFn);
    }

    _calculateHeaderHeight() {
        setTimeout(() => {
            if(this.el) document.documentElement.style.setProperty('--header-height', `${this.el.clientHeight}px`);
            if(this.elMobile) document.documentElement.style.setProperty('--mobile-header-height', `${this.elMobile.clientHeight}px`);
        }, 10);
    }

    _onScroll() {
        this.lastScrollPosition = window.scrollY;

        if(!this.isTicking) {
            this.isTicking = true;

            window.requestAnimationFrame(this.updateFn);
        }
    }

    _update() {
        this.isTicking = false;

        if (!this.isSticky && this.lastScrollPosition >= this.stickyOffset) {
            if(this.el) {
                this.el.classList.add('site-header--sticky');
                setTimeout(() => {
                    this.el.classList.add('site-header--entered');
                });
            }

            if(this.elMobile) {
                this.elMobile.classList.add('site-header--sticky');
                setTimeout(() => {
                    this.elMobile.classList.add('site-header--entered');
                });
            }

            this.isSticky = true;
        } 
        else if (this.isSticky && this.lastScrollPosition < this.stickyOffset) {
            if(this.el) this.el.classList.remove('site-header--sticky', 'site-header--entered');
            if(this.elMobile) this.elMobile.classList.remove('site-header--sticky', 'site-header--entered');

            this.isSticky = false;
        }
    }
}

export default SiteHeader;